"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchPreviewContainer = void 0;
var ToggleMenuFlyout = _interopRequireWildcard(require("@ori-events/toggle-menu-flyout"));
var _presentationHooks = require("@ori/presentation-hooks");
var _configurationContext = require("../../../../context/configurationContext");
var _navigation = require("../../../../context/navigation");
var _topAreaBannerContext = require("../../../../context/topAreaBannerContext");
var _SearchPreview = require("../../../SearchPreview");
var _SearchPreviewSkeleton = require("../../../SearchPreviewSkeleton");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const SearchPreviewContainer = ({
  query
}) => {
  const {
    activeMenu
  } = (0, _navigation.useActiveMenu)();
  const {
    height
  } = (0, _presentationHooks.useWindowSize)();
  const {
    results,
    isLoading
  } = (0, _navigation.useSearchInput)();
  const isActive = activeMenu === ToggleMenuFlyout.MenuTypes.SearchResults;
  const {
    visible: isTopBannerVisible
  } = (0, _topAreaBannerContext.useTopAreaBanner)();
  const {
    showSearchOnScroll
  } = (0, _configurationContext.useAppConfig)();
  if (!isActive || !query) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SearchPreviewRoot, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SearchPreviewContent, {
      innerHeight: height,
      isTopBannerVisible: isTopBannerVisible,
      showSearchOnScroll: showSearchOnScroll,
      children: isLoading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_SearchPreviewSkeleton.SearchPreviewSkeleton, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_SearchPreview.SearchPreview, {
        query: query,
        numberOfProducts: results?.numberOfProducts ?? 0,
        products: results?.products ?? [],
        suggestions: results?.suggestions ?? [],
        brands: results?.brands ?? [],
        categories: results?.categories ?? []
      })
    })
  });
};
exports.SearchPreviewContainer = SearchPreviewContainer;
//# sourceMappingURL=SearchPreviewContainer.js.map